import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Send, Sparkles } from 'lucide-react';

const SCORCIATOIE = [
  'Com’è andato ieri?',
  'Quanto ho speso questo mese?',
  'Aumenti oltre il 10%',
];

/** Barra fissa in fondo alla home: si scrive la domanda e si apre l'assistente. */
export const BarraAssistente = () => {
  const navigate = useNavigate();
  const [domanda, setDomanda] = useState('');

  const apri = (testo) => {
    const q = (testo ?? domanda).trim();
    navigate('/assistente', q ? { state: { domanda: q } } : undefined);
  };

  return (
    <div
      className="fixed left-0 right-0 z-30 border-t border-border bg-white/95 backdrop-blur-md"
      style={{ bottom: 'calc(4rem + env(safe-area-inset-bottom))' }}
      data-testid="home-barra-assistente"
    >
      <div className="max-w-lg mx-auto px-4 py-2.5 space-y-2">
        <div className="flex gap-2 overflow-x-auto pb-0.5">
          {SCORCIATOIE.map((s, i) => (
            <button
              key={s}
              onClick={() => apri(s)}
              className="shrink-0 px-2.5 py-1 rounded-full bg-secondary text-[11px] font-medium text-muted-foreground hover:text-foreground transition-colors"
              data-testid={`home-assistente-scorciatoia-${i}`}
            >
              {s}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <div className="relative flex-1">
            <Sparkles className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-primary" />
            <Input
              value={domanda}
              onChange={(e) => setDomanda(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && apri()}
              placeholder="Chiedi all’assistente…"
              className="h-11 pl-9"
              data-testid="home-assistente-input"
            />
          </div>
          <Button
            size="icon"
            className="h-11 w-11 shrink-0"
            onClick={() => apri()}
            data-testid="home-assistente-invia"
          >
            <Send className="w-5 h-5" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BarraAssistente;
